module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAAsklEQVQoU73RK06DYRCF4WcCggpgE01IW1bQJZBUdQ/46moMgmAQVGHRvUhYQkUralhDVfWQT0C+/CnlIhh75p05cyYy8wqPOHe4Es+RmStcftP8KRdgg4u/AAtMvwBbuMVxveEVM0QDKt7PMG4CP3JVb7jBXUU9YdCcUgM7vFWWujg6BPza0v8CS5yive+GNXqVMIqI+8ws/xihpHfyoZeUhphgi+uIeKmnZmYHD+hj/g7bU08gUbuq5AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/flightDetail/noteImg.png
// module id = Z9qn
// module chunks = 2